(function () {
  var root = document.getElementById('exp002-pp');
  if (!root) return;
  var list = root.querySelector('.exp002-sl__list');
  var dots = root.querySelector('.exp002-sl__dots');
  function perPage() { return window.matchMedia('(max-width:749px)').matches ? 2 : 3; }
  function step() {
    var item = list.querySelector('li');
    return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(item).marginRight) : 0;
  }
  function buildDots() {
    var count = list.children.length;
    var pages = Math.max(1, count - perPage() + 1);
    dots.innerHTML = '';
    for (var i = 0; i < pages; i++) dots.appendChild(document.createElement('b'));
    updateDots();
  }
  function updateDots() {
    var size = step();
    if (!size) return;
    var current = Math.round(list.scrollLeft / size);
    [].forEach.call(dots.children, function (dot, index) {
      dot.classList.toggle('on', index === Math.min(current, dots.children.length - 1));
    });
  }
  list.addEventListener('scroll', function () { window.requestAnimationFrame(updateDots); });
  root.querySelector('.exp002-sl__btn--p').addEventListener('click', function () {
    list.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  root.querySelector('.exp002-sl__btn--n').addEventListener('click', function () {
    list.scrollBy({ left: step(), behavior: 'smooth' });
  });
  [].forEach.call(list.querySelectorAll('video'), function (video) {
    video.addEventListener('loadedmetadata', function () {
      root.classList.add('is-on');
      buildDots();
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    });
    video.addEventListener('error', function () {
      var item = video.parentNode;
      if (item && item.parentNode) {
        item.parentNode.removeChild(item);
        buildDots();
      }
    });
  });
})();
